import { Component, input } from "@angular/core";

@Component({
  selector: "app-code-block",
  templateUrl: "./code-block.html",
  styleUrls: ["./code-block.scss"],
})
export class CodeBlock {
  content = input.required<string>();
}